import * as React from "react";
import Input from "../Input-new/Input";

const NotesInfo = ({ data, viewMode, deleted, handleChangeInput }) => {
    // const [notesValue, setNotesValue] = React.useState();
    
    return (
        <div className="Notes-info">
            <div className="Notes-info_column Notes-info-box">
                <Input
                    className="Notes-info_column_item"
                    required
                    valueType="text"
                    inputType="textarea"
                    name="NOTES"
                    label="Notes"
                    value={data.NOTES}
                    viewMode={viewMode}
                    handleParentChange={handleChangeInput}
                    deleted={deleted}
                />
            </div>
        </div>
    );
};

export default NotesInfo;
